import { render, staticRenderFns } from "./Subcategory.vue?vue&type=template&id=c5ed1f3e&scoped=true&"
import script from "./Subcategory.vue?vue&type=script&lang=js&"
export * from "./Subcategory.vue?vue&type=script&lang=js&"
import style0 from "./Subcategory.vue?vue&type=style&index=0&id=c5ed1f3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5ed1f3e",
  null
  
)

export default component.exports